import Reveal from "@/pages/home/components/Reveal";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <Reveal className={isCenter ? "text-center" : ""}>
      <span className="inline-flex items-center gap-2 font-label text-xs tracking-[0.28em] text-primary-600">
        <i className="ri-bookmark-2-line text-base leading-none"></i>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {desc ? (
        <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${isCenter ? "mx-auto" : ""}`}>
          {desc}
        </p>
      ) : null}
      <span className={`mt-5 block h-px w-16 bg-gradient-to-r from-primary-500 to-transparent ${isCenter ? "mx-auto" : ""}`}></span>
    </Reveal>
  );
}